/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{nativeArrayMaxSize as r}from"../../core/typedArrayUtil.js";function e(e,n=!1){return e<=r?n?new Array(e).fill(0):new Array(e):new Uint8Array(e)}export{e as newUByteArray};
